"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next13_utils_common_get_cookie_1 = __importDefault(require("@gerenciatd/next13.utils.common.get-cookie"));
const getGaCookie = () => {
    let ga = (0, next13_utils_common_get_cookie_1.default)('_ga') || '';
    const gaTokkens = ga.split('.');
    if (gaTokkens.length > 2) {
        ga = gaTokkens.slice(2).join('.');
    }
    return ga;
};
exports.default = getGaCookie;
//# sourceMappingURL=index.js.map